import script from "./ArtifactsList.vue?vue&type=script&setup=true&lang=js"
export * from "./ArtifactsList.vue?vue&type=script&setup=true&lang=js"

import "./ArtifactsList.vue?vue&type=style&index=0&id=02224355&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02224355"]])

export default __exports__